/**
 * Pluralizes a list for display by comma separating and optionally adding "and".
 *
 * Examples:
 *   pluralizeList(['apple']) => 'apple'
 *   pluralizeList(['apple', 'banana']) => 'apple and banana'
 *   pluralizeList(['apple', 'banana', 'cherry']) => 'apple, banana and cherry'
 *
 * @param {string[]} items - the items to join
 * @param {Object} [opts]
 * @param {boolean} [opts.oxfordComma=true] - whether to use Oxford comma
 * @param {string} [opts.andWord='and'] - replacement for "and"
 * @returns {string}
 */
export function pluralizeList(items, opts = {}) {
  const {oxfordComma = true, andWord = 'and'} = opts;
  if (!Array.isArray(items)) return '';
  const len = items.length;
  if (len === 0) return '';
  if (len === 1) return items[0];
  if (len === 2) return `${items[0]} ${andWord} ${items[1]}`;
  const head = items.slice(0, -1).join(', ');
  const tail = items[len - 1];
  return oxfordComma
    ? `${head}, ${andWord} ${tail}`
    : `${head} ${andWord} ${tail}`;
}
